import React from 'react'
import { CircularProgress, Container, Typography, Box } from '@mui/material'
import EmptyEmailIcon from 'src/assets/inboxHub/EmptyEmailIcon.svg'

const NoDataAndWaitingWrapper = ({
  children,
  isLoading,
  loadingText,
  isError,
  errorText,
  data,
  noDataText,
  noDataUi
}) => {
  return (
    <>
      {isLoading
        ? (
          <Container
            sx={{
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 5
            }}
          >
            {isLoading && <CircularProgress />}
            <Typography color='rgba(0, 0, 0, 0.35)' textAlign='center'>{isError ? errorText : loadingText}</Typography>
          </Container>
          )
        : !isError && !isLoading && !data
            ? (
              <Box
                sx={{
                  height: '95%',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: 5,
                  overflow: 'hidden'
                }}
              >
                {noDataUi || (
                  noDataText === 'empty'
                    ? (
                      <Box
                        component='img'
                        src={EmptyEmailIcon}
                        alt='Empty Email'
                        sx={{
                          width: '100%',
                          height: '100%',
                          border: '1px solid #D7D9E6',
                          borderRadius: '12px',
                          maxHeight: '100%',
                          maxWidth: '100%',
                          objectFit: 'cover'
                        }}
                      />
                      )
                    : (
                      <Box
                        sx={{
                          width: {
                            xs: '100%',
                            xl: '90%',
                            xxl: '80%'
                          },
                          height: {
                            xs: '60vh',
                            lg: '80vh'
                          },
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <Typography color='rgba(0, 0, 0, 0.35)'>{noDataText}</Typography>
                      </Box>
                      )
                )}
              </Box>
              )
            : (
                children
              )}
    </>
  )
}

export default NoDataAndWaitingWrapper
